import { request } from "../api/_base";

export const handleResponse = async (result: Response) => {
  if (result.status == 500) {
    const resp = await result.json();
    throw new Error(resp.message);
  }

  return result.json();
}